// Proje Galeri Verileri - Tüm 46 proje için detay görselleri
// Görseller /public/projects/details/[slug]/ klasöründe barındırılıyor

export const projectGalleries = {
  'innovacare-saglik-turizmi': [
    '/projects/details/innovacare-saglik-turizmi/01.jpg',
    '/projects/details/innovacare-saglik-turizmi/02.jpg',
    '/projects/details/innovacare-saglik-turizmi/03.jpg',
    '/projects/details/innovacare-saglik-turizmi/04.jpg',
    '/projects/details/innovacare-saglik-turizmi/05.jpg',
    '/projects/details/innovacare-saglik-turizmi/06.jpg',
    '/projects/details/innovacare-saglik-turizmi/07.jpg',
    '/projects/details/innovacare-saglik-turizmi/08.jpg',
  ],
  'trendy-art': [
    '/projects/details/trendy-art/01.png',
    '/projects/details/trendy-art/02.png',
    '/projects/details/trendy-art/03.png',
    '/projects/details/trendy-art/04.png',
    '/projects/details/trendy-art/05.png',
    '/projects/details/trendy-art/06.png',
  ],
  'k-lotus-beauty': [
    '/projects/details/k-lotus-beauty/01.jpg',
    '/projects/details/k-lotus-beauty/02.jpg',
    '/projects/details/k-lotus-beauty/03.jpg',
    '/projects/details/k-lotus-beauty/04.jpg',
    '/projects/details/k-lotus-beauty/05.jpg',
    '/projects/details/k-lotus-beauty/06.jpg',
  ],
  'wetnose-veteriner': [
    '/projects/details/wetnose-veteriner/01.jpg',
    '/projects/details/wetnose-veteriner/02.jpg',
    '/projects/details/wetnose-veteriner/03.jpg',
    '/projects/details/wetnose-veteriner/04.jpg',
    '/projects/details/wetnose-veteriner/05.jpg',
    '/projects/details/wetnose-veteriner/06.jpg',
  ],
  'anticorex-coviral': [
    '/projects/details/anticorex-coviral/01.jpg',
    '/projects/details/anticorex-coviral/02.jpg',
    '/projects/details/anticorex-coviral/03.jpg',
    '/projects/details/anticorex-coviral/04.jpg',
  ],
  'sasasapanca': [
    '/projects/details/sasasapanca/01.jpg',
    '/projects/details/sasasapanca/02.jpg',
    '/projects/details/sasasapanca/03.jpg',
    '/projects/details/sasasapanca/04.jpg',
    '/projects/details/sasasapanca/05.jpg',
    '/projects/details/sasasapanca/06.jpg',
  ],
  'kids-a-more': [
    '/projects/details/kids-a-more/01.jpg',
    '/projects/details/kids-a-more/02.jpg',
    '/projects/details/kids-a-more/03.jpg',
    '/projects/details/kids-a-more/04.jpg',
    '/projects/details/kids-a-more/05.jpg',
    '/projects/details/kids-a-more/06.jpg',
  ],
  'eczaonline': [
    '/projects/details/eczaonline/01.jpg',
    '/projects/details/eczaonline/02.jpg',
    '/projects/details/eczaonline/03.jpg',
    '/projects/details/eczaonline/04.jpg',
    '/projects/details/eczaonline/05.jpg',
    '/projects/details/eczaonline/06.jpg',
  ],
  'enmama': [
    '/projects/details/enmama/01.jpg',
    '/projects/details/enmama/02.jpg',
    '/projects/details/enmama/03.jpg',
    '/projects/details/enmama/04.jpg',
    '/projects/details/enmama/05.jpg',
    '/projects/details/enmama/06.jpg',
  ],
  'petqueen': [
    '/projects/details/petqueen/01.jpg',
    '/projects/details/petqueen/02.jpg',
    '/projects/details/petqueen/03.jpg',
    '/projects/details/petqueen/04.jpg',
    '/projects/details/petqueen/05.jpg',
    '/projects/details/petqueen/06.jpg',
  ],
  'yemburada-deltacanli': [
    '/projects/details/yemburada-deltacanli/01.jpg',
    '/projects/details/yemburada-deltacanli/02.jpg',
    '/projects/details/yemburada-deltacanli/03.jpg',
    '/projects/details/yemburada-deltacanli/04.jpg',
    '/projects/details/yemburada-deltacanli/05.jpg',
    '/projects/details/yemburada-deltacanli/06.jpg',
  ],
  'medyatik-office': [
    '/images/projects/medyatik-office/office-01.jpg',
    '/images/projects/medyatik-office/office-02.jpg',
    '/images/projects/medyatik-office/office-03.jpg',
    '/images/projects/medyatik-office/office-04.jpg',
    '/images/projects/medyatik-office/office-05.jpg',
    '/images/projects/medyatik-office/office-06.jpg',
    '/images/projects/medyatik-office/office-07.jpg',
    '/images/projects/medyatik-office/office-08.jpg',
    '/images/projects/medyatik-office/office-09.jpg',
    '/images/projects/medyatik-office/office-10.jpg',
    '/images/projects/medyatik-office/office-11.jpg',
    '/images/projects/medyatik-office/office-12.jpg',
    '/images/projects/medyatik-office/office-13.jpg',
  ],
  'ibrahim-biyikli-koto': [
    '/projects/details/ibrahim-biyikli-koto/01.jpg',
    '/projects/details/ibrahim-biyikli-koto/02.jpg',
    '/projects/details/ibrahim-biyikli-koto/03.jpg',
    '/projects/details/ibrahim-biyikli-koto/04.jpg',
    '/projects/details/ibrahim-biyikli-koto/05.jpg',
    '/projects/details/ibrahim-biyikli-koto/06.jpg',
  ],
  'devfest-google-sponsoru': [
    '/projects/details/devfest-google-sponsoru/01.jpg',
    '/projects/details/devfest-google-sponsoru/02.jpg',
    '/projects/details/devfest-google-sponsoru/03.jpg',
    '/projects/details/devfest-google-sponsoru/04.jpg',
    '/projects/details/devfest-google-sponsoru/05.jpg',
    '/projects/details/devfest-google-sponsoru/06.jpg',
  ],
  'bipet': [
    '/images/projects/bipet/bipet-00.jpg',
    '/images/projects/bipet/bipet-01.jpg',
    '/images/projects/bipet/bipet-02.jpg',
    '/images/projects/bipet/bipet-03.jpg',
    '/images/projects/bipet/bipet-04.jpg',
    '/images/projects/bipet/bipet-05.jpg',
    '/images/projects/bipet/bipet-06.jpg',
    '/images/projects/bipet/bipet-07.jpg',
    '/images/projects/bipet/bipet-08.jpg',
    '/images/projects/bipet/bipet-09.jpg',
    '/images/projects/bipet/bipet-10.jpg',
    '/images/projects/bipet/bipet-11.jpg',
    '/images/projects/bipet/bipet-12.jpg',
    '/images/projects/bipet/bipet-13.jpg',
    '/images/projects/bipet/bipet-14.jpg',
    '/images/projects/bipet/bipet-15.jpg',
    '/images/projects/bipet/bipet-16.jpg',
    '/images/projects/bipet/bipet-17.jpg',
    '/images/projects/bipet/bipet-18.jpg',
    '/images/projects/bipet/bipet-19.jpg',
    '/images/projects/bipet/bipet-20.jpg',
    '/images/projects/bipet/bipet-21.jpg',
    '/images/projects/bipet/bipet-22.jpg',
    '/images/projects/bipet/bipet-23.jpg',
    '/images/projects/bipet/bipet-24.jpg',
    '/images/projects/bipet/bipet-25.jpg',
    '/images/projects/bipet/bipet-26.jpg',
    '/images/projects/bipet/bipet-27.jpg',
    '/images/projects/bipet/bipet-28.jpg',
    '/images/projects/bipet/bipet-29.jpg',
    '/images/projects/bipet/bipet-30.jpg',
    '/images/projects/bipet/bipet-31.jpg',
    '/images/projects/bipet/bipet-32.jpg',
    '/images/projects/bipet/bipet-33.jpg',
    '/images/projects/bipet/bipet-34.jpg',
    '/images/projects/bipet/bipet-35.jpg',
  ],
  'alya-butik-otel': [
    '/projects/details/alya-butik-otel/01.jpg',
    '/projects/details/alya-butik-otel/02.jpg',
    '/projects/details/alya-butik-otel/03.jpg',
    '/projects/details/alya-butik-otel/04.jpg',
    '/projects/details/alya-butik-otel/05.jpg',
    '/projects/details/alya-butik-otel/06.jpg',
    '/projects/details/alya-butik-otel/07.jpg',
    '/projects/details/alya-butik-otel/08.jpg',
    '/projects/details/alya-butik-otel/09.jpg',
    '/projects/details/alya-butik-otel/10.jpg',
    '/projects/details/alya-butik-otel/11.jpg',
    '/projects/details/alya-butik-otel/12.jpg',
    '/projects/details/alya-butik-otel/13.jpg',
    '/projects/details/alya-butik-otel/14.jpg',
    '/projects/details/alya-butik-otel/15.jpg',
    '/projects/details/alya-butik-otel/16.jpg',
    '/projects/details/alya-butik-otel/17.jpg',
    '/projects/details/alya-butik-otel/18.jpg',
    '/projects/details/alya-butik-otel/19.jpg',
    '/projects/details/alya-butik-otel/20.jpg',
    '/projects/details/alya-butik-otel/21.jpg',
  ],
  'umit-usta-pastaneleri': [
    '/projects/details/umit-usta-pastaneleri/01.jpg',
    '/projects/details/umit-usta-pastaneleri/02.jpg',
    '/projects/details/umit-usta-pastaneleri/03.jpg',
    '/projects/details/umit-usta-pastaneleri/04.jpg',
    '/projects/details/umit-usta-pastaneleri/05.jpg',
    '/projects/details/umit-usta-pastaneleri/06.jpg',
  ],
  'zoovital': [
    '/projects/details/zoovital/01.jpg',
    '/projects/details/zoovital/02.jpg',
    '/projects/details/zoovital/03.jpg',
    '/projects/details/zoovital/04.jpg',
    '/projects/details/zoovital/05.jpg',
    '/projects/details/zoovital/06.jpg',
  ],
  'skyfall-lounge': [
    '/projects/details/skyfall-lounge/01.jpg',
    '/projects/details/skyfall-lounge/02.jpg',
    '/projects/details/skyfall-lounge/03.jpg',
    '/projects/details/skyfall-lounge/04.jpg',
    '/projects/details/skyfall-lounge/05.jpg',
    '/projects/details/skyfall-lounge/06.jpg',
  ],
  'golevi-restaurant': [
    '/projects/details/golevi-restaurant/01.jpg',
    '/projects/details/golevi-restaurant/02.png',
    '/projects/details/golevi-restaurant/03.png',
    '/projects/details/golevi-restaurant/04.png',
    '/projects/details/golevi-restaurant/05.png',
    '/projects/details/golevi-restaurant/06.png',
  ],
  'reborn-beauty': [
    '/projects/details/reborn-beauty/01.jpg',
    '/projects/details/reborn-beauty/02.jpg',
    '/projects/details/reborn-beauty/03.jpg',
    '/projects/details/reborn-beauty/04.jpg',
    '/projects/details/reborn-beauty/05.jpg',
    '/projects/details/reborn-beauty/06.jpg',
  ],
  'ozpay-gross-marketleri': [
    '/projects/details/ozpay-gross-marketleri/01.jpg',
    '/projects/details/ozpay-gross-marketleri/02.jpg',
    '/projects/details/ozpay-gross-marketleri/03.jpg',
    '/projects/details/ozpay-gross-marketleri/04.jpg',
    '/projects/details/ozpay-gross-marketleri/05.jpg',
    '/projects/details/ozpay-gross-marketleri/06.jpg',
  ],
  'maryap-gyo': [
    '/projects/details/maryap-gyo/01.jpg',
    '/projects/details/maryap-gyo/02.jpg',
    '/projects/details/maryap-gyo/03.jpg',
    '/projects/details/maryap-gyo/04.jpg',
    '/projects/details/maryap-gyo/05.jpg',
    '/projects/details/maryap-gyo/06.jpg',
  ],
  'livera-energy': [
    '/projects/details/livera-energy/01.png',
    '/projects/details/livera-energy/02.png',
    '/projects/details/livera-energy/03.png',
    '/projects/details/livera-energy/04.png',
    '/projects/details/livera-energy/05.png',
    '/projects/details/livera-energy/06.png',
  ],
  'elektromarket-ledmarketim': [
    '/projects/details/elektromarket-ledmarketim/01.jpg',
    '/projects/details/elektromarket-ledmarketim/02.jpg',
    '/projects/details/elektromarket-ledmarketim/03.jpg',
    '/projects/details/elektromarket-ledmarketim/04.jpg',
    '/projects/details/elektromarket-ledmarketim/05.jpg',
    '/projects/details/elektromarket-ledmarketim/06.jpg',
  ],
  'kitirmama': [
    '/projects/details/kitirmama/01.jpg',
    '/projects/details/kitirmama/02.jpg',
    '/projects/details/kitirmama/03.jpg',
    '/projects/details/kitirmama/04.jpg',
    '/projects/details/kitirmama/05.jpg',
    '/projects/details/kitirmama/06.jpg',
  ],
  'katikci-baba': [
    '/projects/details/katikci-baba/01.jpg',
    '/projects/details/katikci-baba/02.jpg',
    '/projects/details/katikci-baba/03.jpg',
    '/projects/details/katikci-baba/04.jpg',
    '/projects/details/katikci-baba/05.jpg',
    '/projects/details/katikci-baba/06.jpg',
  ],
  'kasaphan-steak-house': [
    '/projects/details/kasaphan-steak-house/01.jpg',
    '/projects/details/kasaphan-steak-house/02.jpg',
    '/projects/details/kasaphan-steak-house/03.png',
  ],
  'prof-dr-tonguc-isken': [
    '/projects/details/prof-dr-tonguc-isken/01.jpg',
    '/projects/details/prof-dr-tonguc-isken/02.jpg',
    '/projects/details/prof-dr-tonguc-isken/03.jpg',
    '/projects/details/prof-dr-tonguc-isken/04.jpg',
    '/projects/details/prof-dr-tonguc-isken/05.jpg',
    '/projects/details/prof-dr-tonguc-isken/06.jpg',
  ],
  'medical-park-vitamor': [
    '/projects/details/medical-park-vitamor/01.png',
    '/projects/details/medical-park-vitamor/02.png',
    '/projects/details/medical-park-vitamor/03.png',
  ],
  'diyetisyen-neslihan-turkoglu': [
    '/projects/details/diyetisyen-neslihan-turkoglu/01.jpg',
    '/projects/details/diyetisyen-neslihan-turkoglu/02.jpg',
    '/projects/details/diyetisyen-neslihan-turkoglu/03.jpg',
    '/projects/details/diyetisyen-neslihan-turkoglu/04.jpg',
    '/projects/details/diyetisyen-neslihan-turkoglu/05.jpg',
    '/projects/details/diyetisyen-neslihan-turkoglu/06.jpg',
  ],
  'medicana-dr-gurdal-oren': [
    '/projects/details/medicana-dr-gurdal-oren/01.jpg',
    '/projects/details/medicana-dr-gurdal-oren/02.jpg',
    '/projects/details/medicana-dr-gurdal-oren/03.jpg',
  ],
  'derindere-hastanesi': [
    '/projects/details/derindere-hastanesi/01.jpg',
    '/projects/details/derindere-hastanesi/02.jpg',
    '/projects/details/derindere-hastanesi/03.jpg',
  ],
  'atakent-hastanesi': [
    '/projects/details/atakent-hastanesi/01.png',
    '/projects/details/atakent-hastanesi/02.png',
    '/projects/details/atakent-hastanesi/03.png',
  ],
  'opark-yasam-merkezi': [
    '/projects/details/opark-yasam-merkezi/01.jpg',
    '/projects/details/opark-yasam-merkezi/02.jpg',
    '/projects/details/opark-yasam-merkezi/03.jpg',
  ],
  'nokta-tv-gazetesi': [
    '/projects/details/nokta-tv-gazetesi/01.jpg',
    '/projects/details/nokta-tv-gazetesi/02.jpg',
    '/projects/details/nokta-tv-gazetesi/03.jpg',
    '/projects/details/nokta-tv-gazetesi/04.jpg',
    '/projects/details/nokta-tv-gazetesi/05.jpg',
    '/projects/details/nokta-tv-gazetesi/06.jpg',
    '/projects/details/nokta-tv-gazetesi/07.jpg',
    '/projects/details/nokta-tv-gazetesi/08.jpg',
    '/projects/details/nokta-tv-gazetesi/09.jpg',
    '/projects/details/nokta-tv-gazetesi/10.jpg',
    '/projects/details/nokta-tv-gazetesi/11.jpg',
    '/projects/details/nokta-tv-gazetesi/12.jpg',
    '/projects/details/nokta-tv-gazetesi/13.jpg',
    '/projects/details/nokta-tv-gazetesi/14.jpg',
    '/projects/details/nokta-tv-gazetesi/15.jpg',
    '/projects/details/nokta-tv-gazetesi/16.jpg',
    '/projects/details/nokta-tv-gazetesi/17.jpg',
    '/projects/details/nokta-tv-gazetesi/18.jpg',
    '/projects/details/nokta-tv-gazetesi/19.jpg',
    '/projects/details/nokta-tv-gazetesi/20.jpg',
    '/projects/details/nokta-tv-gazetesi/21.jpg',
    '/projects/details/nokta-tv-gazetesi/22.jpg',
    '/projects/details/nokta-tv-gazetesi/23.jpg',
    '/projects/details/nokta-tv-gazetesi/24.jpg',
    '/projects/details/nokta-tv-gazetesi/25.jpg',
    '/projects/details/nokta-tv-gazetesi/26.jpg',
    '/projects/details/nokta-tv-gazetesi/27.jpg',
    '/projects/details/nokta-tv-gazetesi/28.jpg',
    '/projects/details/nokta-tv-gazetesi/29.jpg',
    '/projects/details/nokta-tv-gazetesi/30.jpg',
    '/projects/details/nokta-tv-gazetesi/31.jpg',
    '/projects/details/nokta-tv-gazetesi/32.jpg',
    '/projects/details/nokta-tv-gazetesi/33.jpg',
    '/projects/details/nokta-tv-gazetesi/34.jpg',
    '/projects/details/nokta-tv-gazetesi/35.jpg',
  ],
  'ekin-backerei': [
    '/projects/details/ekin-backerei/01.jpg',
    '/projects/details/ekin-backerei/02.jpg',
    '/projects/details/ekin-backerei/03.jpg',
  ],
  'chefistanbul': [
    '/projects/details/chefistanbul/01.jpg',
    '/projects/details/chefistanbul/02.jpg',
    '/projects/details/chefistanbul/03.jpg',
  ],
  'baristaplus': [
    '/projects/details/baristaplus/01.jpg',
    '/projects/details/baristaplus/02.jpg',
    '/projects/details/baristaplus/03.jpg',
  ],
  'kollektif-house': [
    '/projects/details/kollektif-house/01.jpg',
    '/projects/details/kollektif-house/02.jpg',
    '/projects/details/kollektif-house/03.jpg',
  ],
  'jolly-joker': [
    '/projects/details/jolly-joker/01.jpg',
    '/projects/details/jolly-joker/02.jpg',
    '/projects/details/jolly-joker/03.jpg',
  ],
  'izaydas': [
    '/projects/details/izaydas/01.jpg',
    '/projects/details/izaydas/02.jpg',
    '/projects/details/izaydas/03.jpg',
  ],
  'elbet-steak-house': [
    '/projects/details/elbet-steak-house/01.jpg',
    '/projects/details/elbet-steak-house/02.jpg',
    '/projects/details/elbet-steak-house/03.jpg',
  ],
  'sketchplus-cafe': [
    '/projects/details/sketchplus-cafe/01.jpg',
    '/projects/details/sketchplus-cafe/02.jpg',
    '/projects/details/sketchplus-cafe/03.jpg',
  ],
  'golden-palace-hotel': [
    '/projects/details/golden-palace-hotel/01.jpg',
    '/projects/details/golden-palace-hotel/02.jpg',
    '/projects/details/golden-palace-hotel/03.jpg',
  ],
  'garnet-home-design': [
    '/projects/details/garnet-home-design/01.jpg',
    '/projects/details/garnet-home-design/02.jpg',
    '/projects/details/garnet-home-design/03.jpg',
  ],
};

// Slug'a göre galeri getir
export const getGalleryBySlug = (slug) => {
  return projectGalleries[slug] || [];
};

// Toplam galeri sayısı
export const getTotalGalleryCount = () => {
  return Object.keys(projectGalleries).length;
};

// Toplam görsel sayısı
export const getTotalImageCount = () => {
  return Object.values(projectGalleries).reduce((total, images) => total + images.length, 0);
};

export default projectGalleries;
